import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { HomePage } from '../../home/home';
import { AddonsServices } from '../services';



@Component({
  selector: 'page-addons-user-arrival',
  templateUrl: 'addons-user-arrival.html',
})
export class AddonsUserArrivalPage {


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public addonsServices: AddonsServices) {

  }

  close() {
    this.updateUserArrival();

  }

  openVersionPro() {
    this.updateUserArrival();
  }

  updateUserArrival() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();

    this.addonsServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'addon_user_arrival': false,
    }).then(() => {
      //update
      this.globals.restaurant.addon_user_arrival = false;
      //loading dismiss
      loadingPopup.dismiss();
      //link a wordpress
      this.globals.openLandingPricing();
      //nav 
      this.navCtrl.setRoot(HomePage);
    }).catch(() => {
      //loading dismiss
      loadingPopup.dismiss();
      //nav 

    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/addons/addons-user-arrival/addons-user-arrival.ts